import { useState } from 'react'
import { useWindowSize } from '../../../../../core/hooks/common/useWindowSize'
import { TABLET_SIZE } from '../../../../../core/constants/common'
import {
    CacheKeys,
    recipientsOptions,
} from '../../../../../core/constants/filter'
import FilterLayout from '../../../../layout/filter/FilterLayout'
import { useGetAllRecipients } from '../../../../../core/services/react-query/report/due-payments'
import RecipientsTable from './RecipientsTable'
import RRecipientsTable from './RRecipientsTable'

const RecipientsList = () => {
    const { width } = useWindowSize()
    const [recipients, setRecipients] = useState({ data: null, loading: true })


    const onQuerySuccess = (res) => {
        setRecipients(res)
    }

    const Component = width > TABLET_SIZE ? RecipientsTable : RRecipientsTable

    return (
        <FilterLayout
            query={useGetAllRecipients}
            onQuerySuccess={onQuerySuccess}
            options={recipientsOptions}
            cache={CacheKeys.RECIPIENTS}
        >
            {width && <Component data={recipients} />}
        </FilterLayout>
    )
}

export default RecipientsList
